import startCase from 'lodash/startCase';

const getLabel = (label, name, required) => {
    let title = label;
    if (!title && name) {
        title = startCase(name);
    }

    title = title || '';
    if (required) {
        title = `${title}*`;
    }

    return title;
};

export { getLabel };
